import type { GetCurrentUserWorkspaceMembershipsFn } from '@/features/iam'
import { computed } from 'mobx'

/**
 * Scoping permissions of the current user.
 */
export class OCRScopingJobsPermissionViewModel {
  constructor(
    private readonly _getCurrentUserWorkspaceMemberships: GetCurrentUserWorkspaceMembershipsFn,
  ) {}

  @computed
  get canViewScopingJobs() {
    return this._getCurrentUserWorkspaceMemberships().some(
      (wsm) =>
        wsm.member.permissions.scopeWork &&
        wsm.member.permissions.adminScopeWorkView,
    )
  }

  @computed
  get canManageOCRScopingJobs() {
    return this._getCurrentUserWorkspaceMemberships().some(
      (wms) => wms.member.permissions.adminManageOcrJobs,
    )
  }
}
